import {call, put, select} from "typed-redux-saga";
import {
	fetchPredictionSimulateSuccess,
	fetchPredictionSimulateFailed,
	fetchPredictionsSuccess,
	fetchPredictionsFailed,
	savePredictionsSuccess,
	savePredictionsFailed,
	fetchPredictionSimulateLiteFailed,
	fetchPredictionSimulateLiteSuccess,
	savePredictionsInStorage,
} from "apps/DRAW_PREDICTOR/modules/actions";
import {DrawPredictorApi} from "apps/DRAW_PREDICTOR/modules/utils/Api";
import {getAllPredictions, getPickedOptions} from "apps/DRAW_PREDICTOR/modules/selectors";
import {handleModalState} from "apps/DRAW_PREDICTOR/modules/actions/modals";
import {isLoggedIn} from "modules/selectors";

export const fetchPredictionSimulateSaga = function* () {
	try {
		const allPredictions = yield* select(getAllPredictions);
		const isUser = yield* select(isLoggedIn);
		const response = yield* call(
			isUser
				? DrawPredictorApi.predictions.api_prediction_simulate
				: DrawPredictorApi.predictions.api_free_prediction_simulate,
			{
				predictions: allPredictions,
			}
		);
		yield* put(fetchPredictionSimulateSuccess(response.success.predictions));
		yield* put(handleModalState({fanSentiments: true}));
	} catch (err) {
		const {message} = err as Error;
		yield* put(fetchPredictionSimulateFailed(message));
	}
};

export const fetchPredictionSimulateLiteSaga = function* () {
	try {
		const allPredictions = yield* select(getAllPredictions);
		const userSelected = yield* select(getPickedOptions);
		const response = yield* call(DrawPredictorApi.predictions.api_prediction_simulate_lite, {
			predictions: allPredictions,
			user_qualified: userSelected as number[],
		});

		yield* put(fetchPredictionSimulateLiteSuccess(response.success.predictions));
		yield* put(handleModalState({drawConfirmation: true}));
		yield* put(savePredictionsInStorage());
	} catch (err) {
		const {message} = err as Error;
		yield* put(fetchPredictionSimulateLiteFailed(message));
	}
};

export const fetchPredictionsSaga = function* () {
	try {
		const response = yield* call(DrawPredictorApi.predictions.predictions);
		yield* put(fetchPredictionsSuccess(response.success.predictions));
	} catch (err) {
		const {message} = err as Error;
		yield* put(fetchPredictionsFailed(message));
	}
};

export const savePredictionsSaga = function* () {
	try {
		const allPredictions = yield* select(getAllPredictions);
		const response = yield* call(DrawPredictorApi.predictions.save_predictions, {
			predictions: allPredictions,
		});
		yield* put(savePredictionsSuccess(response.success.predictions));
	} catch (err) {
		const {message} = err as Error;
		yield* put(savePredictionsFailed(message));
	}
};
